import { ProductCategoryInterface } from "../../interfaces/apiV2/shared/ProductCategoryInterface";

export const isLeafCategory = (
    category: Pick<ProductCategoryInterface, "children">,
): boolean => category.children.length === 0;
